import {Order} from "@/model/Order";
import {OrdersListSummary} from "@/model/OrdersListSummary";
import { OrderedProduct } from "@/model/OrderedProduct";

export class OrderedProductsList {
    summary: OrdersListSummary;
    productsToProcess: OrderedProduct[];
    productsProcessed: OrderedProduct[];
}